import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';

const SOURCE_VIEW = 'noJobsPage';

@Component({
  selector: 'app-no-jobs',
  templateUrl: './no-jobs.component.html',
  styleUrls: ['./no-jobs.component.scss'],
})
export class NoJobsComponent implements OnInit {

  private readonly APP_TEXT: string = 'New jobs are added daily. Check that you have notifications enabled and never miss out on your next opportunity!';
  private readonly WEB_TEXT: string = 'New jobs are added daily. Download the Bluecrew app to receive notifications and never miss out on your next opportunity!';

  @Input() shouldAddHeaderSpacing?: boolean = false;

  constructor(
    private readonly platform: Platform,
    private readonly segmentCMOS: SegmentCMOSService,
    private openNativeSettings: OpenNativeSettings
  ) { }

  ngOnInit() { }

  getBodyText() {
    return this.isMobile() ? this.APP_TEXT : this.WEB_TEXT;
  }

  isMobile() {
    return this.platform.is('hybrid')
  }

  async openNotificationSettings() {
    this.segmentCMOS.addEvent('openNativeSettings', { sourceView: SOURCE_VIEW, setting: 'application_details' });
    await this.openNativeSettings.open('application_details');
  }
}
